export default "__VITE_ASSET__CJSjVE_k__"